import { render } from "./UnderlinedTitle.vue?vue&type=template&id=254a4be6&scoped=true"
import script from "./UnderlinedTitle.vue?vue&type=script&lang=js"
export * from "./UnderlinedTitle.vue?vue&type=script&lang=js"

import "./UnderlinedTitle.vue?vue&type=style&index=0&id=254a4be6&lang=less&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254a4be6"]])

export default __exports__